import {useEffect, useRef} from 'react';
import ReactGA from 'react-ga4';
import {useLocation} from 'react-router-dom';

export default function PageViewTracker() {
  const location = useLocation();
  const previousPathRef = useRef<string | null>(null);

  useEffect(() => {
    const currentPath = location.pathname + location.search;

    if (previousPathRef.current !== currentPath) {
      ReactGA.send({
        hitType: 'pageview',
        page: currentPath,
        title: document.title,
      });
      previousPathRef.current = currentPath;
    }
  }, [location]);

  return null;
}
